import button from './button.vue'
import email from './email.vue'
import password from './password.vue'
import search from './search.vue'
import inputdate from './inputdate.vue'
import select2 from './select2.vue'
import multipleselect2 from './multipleselect2.vue'
import formgrouptext from './formgrouptext.vue'
import formgroupquestion from './formgroupquestion.vue'
import formgroupphone from './formgroupphone.vue'
import formgroupsocialsecurityno from './formgroupsocialsecurityno.vue'
import formgroupdatepicker from './formgroupdatepicker.vue'
import formgrouptextphone from './formgrouptextphone.vue'
import formgrouptextarea from './formgrouptextarea.vue'
import formgroupdate from './formgroupdate.vue'
import formgroupupload from './formgroupupload.vue'
import formgroupswitch from './formgroupswitch'
import formswitch from './switch.vue'
import formgroupdoubleswitch from './formgroupdoubleswitch'

import formgroupWYSIWYG from './formgroupWYSIWYG.vue'
import formgroupselect2 from './formgroupselect2.vue'
import daterangepicker from './daterangepicker/index.vue'
import checkboxuniform from './checkboxuniform'

import price from './price.vue'
export default {
	button,
	email,
	password,
	search,
	inputdate,
	select2,
	multipleselect2,
	formgrouptext,
	formgroupquestion,
	formgroupdatepicker,
	formgrouptextphone,
	formgroupsocialsecurityno,
	formgroupphone,
	formgrouptextarea,
	formgroupdate,
	formgroupupload,
	formgroupWYSIWYG,
	formgroupselect2,
	formgroupswitch,
	formgroupdoubleswitch,
	daterangepicker,
	checkboxuniform,
	formswitch,
	price
}